import { eventPreventDefault, stopEventPropagation } from '@lyearn/core/utils/events';

interface Params {
  preventDefault: VoidFunction;
  stopPropagation: VoidFunction;
}

export default function stopPropagation(event: Params) {
  stopEventPropagation(event);
  eventPreventDefault(event);
}
